import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    mensajitoToken: "",
    mensajitoUser: []
  },
  mutations: {
    login(state, data) {
      state.mensajitoUser = data.user;
      state.mensajitoToken = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.mensajitoUser = [];
      state.mensajitoToken = "";
    },
    usuario(state, data) {
      state.usuario = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("usuario", data);
    }
  }
});
